import { Collectable } from '../collectables';

export function hasCollectableData(collectable?: Collectable): boolean {
  if (!collectable) return false;

  return Object.values(collectable).some(value => value !== undefined);
}
